export default {
  id: {
    value: '',
    options: [],
    clearOption: true,
    required: false,
    state: null,
    defaultValue: '00000000-0000-0000-0000-000000000000'
  },
  regulationAutoID: {
    value: null,
    options: [],
    clearOption: true,
    required: true,
    state: null,
    defaultValue: null
  },
  valueGlassware: {
    value: '',
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  withSuppliedParts: {
    value: '',
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  withoutSuppliedParts: {
    value: '',
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  valueFranchise: {
    value: '',
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  autoTypeID: {
    value: null,
    options: [],
    required: false,
    state: null,
    defaultValue: null
  },
  brandID: {
    value: null,
    options: [],
    clearOption: true,
    required: false,
    state: null,
    defaultValue: null
  },
  autoModelID: {
    value: null,
    options: [],
    clearOption: true,
    required: false,
    state: null,
    defaultValue: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/inspection/workshopreturn/sinisterworkshopreturn-form.js